import { useEffect, useState } from 'react'

function useCounterInput(
  initialValue: number,
  minValue?: number,
  maxValue?: number,
  onAdd?: Function,
  onRemove?: Function,
  onChangeValue?: (counter: number) => void,
): [number, () => void, () => void] {
  const [counter, setCounter] = useState<number>(0)

  useEffect(() => {
    setCounter(initialValue)
  }, [initialValue])

  const add = () => {
    if (maxValue === undefined || counter <= maxValue) {
      const new_val = counter + 1
      setCounter(new_val)
      if (onAdd) onAdd()
      if (onChangeValue) onChangeValue(new_val)
    }
  }
  const remove = () => {
    if (minValue === undefined || counter >= minValue) {
      const new_val = counter - 1
      setCounter(new_val)
      if (onRemove) onRemove()
      if (onChangeValue) onChangeValue(new_val)
    }
  }

  return [counter, add, remove]
}

export default useCounterInput
